<app-collection-criteria-form (criteria)="onSearch($event)"></app-collection-criteria-form>
<div id="content">
  <app-collection-list #list [sorting]="sorting" (page)="onScroll()" (sort)="onSort($event)"></app-collection-list>
</div>